import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OnboardingTheme, Template } from "../types";

const initialState: Template = {
  onboardingType: null,
  formTitle: "",
  logo: "",
  steps: null,
  icon: "",
  preconfirmation: null,
  favicon: "",
  theme: null,
};

const activeTemplateSlice = createSlice({
  name: "activeTemplate",
  initialState,
  reducers: {
    onUpdateOnboardingType: (state, action) => {
      return { ...state, onboardingType: action.payload };
    },
    onUpdateTheme: (state, action: PayloadAction<OnboardingTheme>) => {
      return {
        ...state,
        theme: action.payload,
      };
    },
    onUpdateActiveTemplate: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    onResetActiveTemplate: () => {
      return initialState;
    },
  },
});

export const {
  onUpdateOnboardingType,
  onUpdateActiveTemplate,
  onUpdateTheme,
  onResetActiveTemplate,
} = activeTemplateSlice.actions;

export default activeTemplateSlice.reducer;
